export const videoData = [
    {
        "id": 1,
        "name":"New Member",
        "summary":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt?",
        "modify": "1 hour ago",
        "icon": "fa fa-play-circle",
        "folderclass": "fa fa-file-archive-o f-36 txt-warning",
        "title": "Endless Admin",
        "foldersize": "204 files, 50mb"
    },
    {
        "id": 2,
        "name":"New Member",
        "summary":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt?",
        "modify": "1 hour ago",
        "icon": "fa fa-play-circle",
        "folderclass": "fa fa-folder f-36 txt-warning",
        "title": "Endless Admin",
        "foldersize": "101 files, 10mb"
    },
    {
        "id": 3,
        "name":"New Member",
        "summary":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt?",
        "modify": "1 hour ago",
        "icon": "fa fa-play-circle",
        "folderclass": "fa fa-file-archive-o f-36 txt-warning",
        "title": "Endless Admin",
        "foldersize": "25 files, 2mb"
    },
    {
        "id": 4,
        "name":"New Member",
        "summary":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt?",
        "modify": "1 hour ago",
        "icon": "fa fa-play-circle",
        "folderclass": "fa fa-folder f-36 txt-warning",
        "title": "Endless Admin",
        "foldersize": "108 files, 5mb"
    },
    {
        "id": 5,
        "name":"New Member",
        "summary":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt?",
        "modify": "1 hour ago",
        "icon": "fa fa-play-circle",
        "folderclass": "fa fa-file-archive-o f-36 txt-warning",
        "title": "Endless Admin",
        "foldersize": "204 files, 50mb"
    },
    {
        "id": 6,
        "name":"New Member",
        "summary":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt?",
        "modify": "1 hour ago",
        "icon": "fa fa-play-circle",
        "folderclass": "fa fa-file-archive-o f-36 txt-warning",
        "title": "Endless Admin",
        "foldersize": "204 files, 50mb"
    },
    {
        "id": 7,
        "name":"New Member",
        "summary":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt?",
        "modify": "1 hour ago",
        "icon": "fa fa-play-circle",
        "folderclass": "fa fa-file-archive-o f-36 txt-warning",
        "title": "Endless Admin",
        "foldersize": "204 files, 50mb"
    },
    {
        "id": 8,
        "name":"New Member",
        "summary":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt?",
        "modify": "1 hour ago",
        "icon": "fa fa-play-circle",
        "folderclass": "fa fa-file-archive-o f-36 txt-warning",
        "title": "Endless Admin",
        "foldersize": "204 files, 50mb"
    },
    {
        "id": 9,
        "name":"New Member",
        "summary":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt?",
        "modify": "1 hour ago",
        "icon": "fa fa-play-circle",
        "folderclass": "fa fa-file-archive-o f-36 txt-warning",
        "title": "Endless Admin",
        "foldersize": "204 files, 50mb"
    },
    {
        "id": 10,
        "name":"New Member",
        "summary":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt?",
        "modify": "1 hour ago",
        "icon": "fa fa-play-circle",
        "folderclass": "fa fa-file-archive-o f-36 txt-warning",
        "title": "Endless Admin",
        "foldersize": "204 files, 50mb"
    },
    {
        "id": 11,
        "name":"New Member",
        "summary":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt?",
        "modify": "1 hour ago",
        "icon": "fa fa-play-circle",
        "folderclass": "fa fa-file-archive-o f-36 txt-warning",
        "title": "Endless Admin",
        "foldersize": "204 files, 50mb"
    },
]